import { combineReducers } from "redux";

const root = combineReducers({
    // data

});

export default root;